import { useBasePurchase } from '../../../hooks/purchases/useBasePurchase';
import { usePurchaseButtonActions } from '../../../hooks/purchases/usePurchaseButtonActions';
import { ActionItem } from '../../../types/button/ActionButton';

export const usePurchasePdfModalActions = (): ActionItem[] => {
    const { handlerConsultDTE, handlerDownloadJson, handlerSendByEmail } = usePurchaseButtonActions();
    const { form } = useBasePurchase();

    return [
        {
            key: 'json',
            onClick: () => handlerDownloadJson(form.id),
        },
        {
            key: 'dte',
            onClick: () => handlerConsultDTE(form.id),
        },
        {
            key: 'email',
            onClick: () => handlerSendByEmail(form.id),
        },
    ];
};